import React from "react";
import { Route, IndexRoute } from "react-router";
import NotFound from "./view/error/NotFound";
import NotAuthorization from "./view/error/NotAuthorization";
import Forbidden from "./view/error/Forbidden";
import AppModule from "./components/containers/AppModule";
import { UnsupportedBrowser } from "react-template";
import Index from "./view/dashboard/Index";

//FORM
import VisualizarFormulario from "./components/formbuilder/menu/ShowForm";
import ListAllForm from "./view/formulario/list/ListAllForm";
import FormHome from "./view/formulario/list/tabs/FormHome";
import FormSubscribed from "./view/formulario/list/tabs/FormSubscribed";
import FormCertifielData from "./view/formulario/list/tabs/FormCertifielData";
import NovoModeloCertificado from "./view/formulario/list/tabs/NovoModeloCertificado";
import NewForm from "./view/formulario/new/NewForm";
import FormLayout from "./view/formulario/list/tabs/FormLayout";

//GRU
import NewGRU from "./view/gru/new/NewGRU";
import ListarGRU from "./view/gru/list/ListAllGRU";
import ListarGRUPreenchivel from "./view/gru/list/ListAllFillableGRU";
import GRUHome from "./view/gru/list/tabs/GRUHome";
import GRULayout from "./view/gru/list/tabs/GRULayout";
import GRUSubscribed from "./view/gru/list/tabs/GRUSubscribed";
import Search from "./view/gru/search/Search";

// Paginas do Incio
import Inicio from "./view/inicio";
import InicioForms from "./view/inicio/Forms";
import InicioTodosForms from "./view/inicio/FormsTodos";
import InicioGRUs from "./view/inicio/GRUs";
import InicioInscricoes from "./view/inicio/MySubscriptions";
import InicioInscricaoForm from "./view/inicio/FormSubscription";
import InicioInscricaoGRU from "./view/inicio/GRUSubscription";
import ConfirmarEmail from "./view/formulario/confirmacao/ConfirmarEmail";

//formularios internos
import ListInternalForms from "./view/internal_forms/ListInternalForms";
import InternalFormSubscription from "./view/internal_forms/InternalFormSubscription";
import ListInternalSubscriptions from "./view/internal_forms/ListInternalSubscriptions";

import ValidarCertificado from "./view/validacao/ValidarCertificado";

import Login from "./auth/components/Login";
import Logout from "./auth/components/Logout";
import { Authorization } from "./auth/components/Authorization";
const AdminFormRole = Authorization(["ADMINISTRADOR FORMS", "GERENTE FORMS"]);
const AdminGRURole = Authorization(["ADMINISTRADOR GRU", "GERENTE GRU"]);
const ManagerGRURole = Authorization(["GERENTE GRU"]);
const All = Authorization([
  "ADMINISTRADOR GRU",
  "ADMINISTRADOR FORMS",
  "GERENTE FORMS",
  "GERENTE GRU",
  "ROLE_AUTHENTICATED"
]);

export default (
  <div>
    <Route path="/" component={AppModule} exact>
      {/*Páginas iniciais*/}
      <Route component={Inicio} public>
        <IndexRoute component={InicioForms} public />
        <Route path="/formularios" exact component={InicioTodosForms} public />
        <Route path="/grus" exact component={InicioGRUs} public />
        <Route path="/inscricoes" exact component={InicioInscricoes} public />
        <Route
          path="/validarcertificado/:id"
          exact
          component={ValidarCertificado}
          public
        />
        <Route
          path="/responderFormulario/:id"
          exact
          component={InicioInscricaoForm}
          public
        />
        <Route
          path="/responderGRU/:id"
          exact
          component={InicioInscricaoGRU}
          public
        />
        <Route
          path="/confirmacao/:cod"
          exact
          component={ConfirmarEmail}
          public
        />
      </Route>

      <Route path="admin" name="Início">
        <IndexRoute titulo="Início" exact component={All(Index)} />

        {/*Internos*/}
        <Route path="formularios-internos" name="Formulários Internos">
          <IndexRoute
            name="Formulários Internos"
            titulo="Formulários Internos"
            component={All(ListInternalForms)}
          />
          <Route
            path=":id"
            titulo="Preencher formulários internos"
            exact
            component={All(InternalFormSubscription)}
          />
        </Route>
        <Route
          path="inscricoes-internas"
          titulo="Inscrições de formulários internos"
          exact
          component={All(ListInternalSubscriptions)}
        />

        {/*Formulários*/}
        <Route path="formulario" name="Formulários">
          <IndexRoute
            name="Formulários"
            titulo="Listar Formulários"
            component={AdminFormRole(ListAllForm)}
          />
          <Route
            path="novo"
            name="Novo Formulário"
            titulo="Novo formulário"
            exact
            component={AdminFormRole(NewForm)}
          />

          <Route name="Detalhar" titulo="Detalhar" path=":id" staticName={true}>
            <Route component={AdminFormRole(VisualizarFormulario)}>
              <IndexRoute
                name="Detalhar"
                titulo="Detalhar"
                component={FormHome}
                staticName={true}
              />
              <Route
                path="inscritos"
                name="Inscritos"
                titulo="Inscritos"
                exact
                component={FormSubscribed}
              />
              <Route
                path="certificado"
                name="Dados do Certificado"
                titulo="Dados do Certificado"
                exact
                component={FormCertifielData}
              />
              <Route
                path="certificado/modelo"
                name="Novo Modelo de Certificado"
                titulo="Novo Modelo de Certificado"
                exact
                component={NovoModeloCertificado}
              />
            </Route>

            <Route
              path="editar"
              name="Editar"
              titulo="Editar Formulário"
              exact
              component={FormLayout}
            />
          </Route>
        </Route>

        {/*GRU*/}
        <Route path="gru" name="GRU">
          <IndexRoute
            name="GRU"
            titulo="Listar GRUs"
            component={AdminGRURole(ListarGRU)}
          />
          <Route
            path="novo"
            name="Nova GRU"
            titulo="Nova GRU"
            exact
            component={AdminGRURole(NewGRU)}
          />
          <Route
            path="consultar"
            name="Consultar"
            titulo="Consultar GRU"
            exact
            component={AdminGRURole(Search)}
          />
          <Route name="Detalhar" titulo="Detalhar" path=":id" staticName={true}>
            <Route component={AdminGRURole(VisualizarFormulario)}>
              <IndexRoute
                name="Detalhar"
                titulo="Detalhar"
                component={GRUHome}
                staticName={true}
              />
              <Route
                path="historico"
                name="Historico"
                titulo="Historico"
                exact
                component={GRUSubscribed}
              />
            </Route>

            <Route
              path="editar"
              name="Editar"
              titulo="Editar GRU"
              exact
              component={GRULayout}
            />
          </Route>
        </Route>
        <Route path="fill" name="Preencher">
          <IndexRoute
            name="Preencher GRUs"
            titulo="GRUs Ativos"
            component={ManagerGRURole(ListarGRUPreenchivel)}
          />
          <Route name="Preencher" titulo="Preencher" path=":id" staticName={true}>
            <Route component={ManagerGRURole(VisualizarFormulario)}>
              <IndexRoute
                name="Preencher"
                titulo="Preencher"
                component={GRUHome}
                staticName={true}
              />
            </Route>
          </Route>
        </Route>
      </Route>
      <Route path="/401" component={NotAuthorization} public />
      <Route path="/403" component={Forbidden} public />
      <Route path="/404" component={NotFound} public />
      <Route path="/navegadores" component={UnsupportedBrowser} exact public />
      <Route path="/login" component={Login} public />
      <Route path="/logout" component={Logout} public />
      <Route path="*" component={Login} public />
    </Route>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes.js